import { eventTrackApi } from '@/api/tracking.js';
import { getDevice } from '@/utils/getdevice.js';

export const EVENT_TYPE_ENUM = {
  platform_group_square_page_show: 'platform_group_square_page_show',
  platform_group_square_button: 'platform_group_square_button',
  platform_group_info_button: 'platform_group_info_button',
  platform_group_user_center_tab_click: 'platform_group_user_center_tab_click',
  platform_group_user_center_post_click: 'platform_group_user_center_post_click',
  platform_group_user_center_save_button: 'platform_group_user_center_save_button',
  platform_group_home_button: 'platform_group_home_button',
  platform_group_home_navigation_click: 'platform_group_home_navigation_click',
  platform_group_home_post_click: 'platform_group_home_post_click',
  platform_group_home_tag_click: 'platform_group_home_tag_click',
  platform_group_home_post_opt_click: 'platform_group_home_post_opt_click',
  platform_group_post_detail_praise_comment: 'platform_group_post_detail_praise_comment',
  platform_group_save_post_click: 'platform_group_save_post_click',
};

export const FORUM_TRACKING_CHANNEL = 'heimiao';

const getNavigator = () => {
  if (typeof window === 'undefined' || !window.navigator) return {};
  return window.navigator;
};

const getConnection = navigatorInfo =>
  navigatorInfo.connection || navigatorInfo.mozConnection || navigatorInfo.webkitConnection || {};

const normalizeId = value => {
  if (typeof value === 'number' && isFinite(value) && value > 0) return value;
  if (typeof value !== 'string') return '';

  const trimmed = value.trim();
  const lowered = trimmed.toLowerCase();
  if (!trimmed || trimmed === '0' || lowered === 'null' || lowered === 'undefined') return '';
  return trimmed;
};

const stringifyEventField = params => {
  if (!params) return '';
  const result = JSON.stringify(params);
  return typeof result === 'string' ? result : '';
};

const isPlainObject = value => Object.prototype.toString.call(value) === '[object Object]';

const pickId = (...values) => {
  for (const value of values) {
    const id = normalizeId(value);
    if (id !== '') return id;
  }
  return '';
};

const withForumTrackingChannel = params => {
  if (!isPlainObject(params)) return params;
  return {
    ...params,
    channel: FORUM_TRACKING_CHANNEL,
  };
};

const parseSystemVersion = (ua, device) => {
  if (device.android) {
    const androidMatch = ua.match(/Android\s+([\d.]+)/);
    return androidMatch ? androidMatch[1] : '';
  }
  if (device.ios) {
    const iosMatch = ua.match(/OS\s([\d_]+)/);
    return iosMatch ? iosMatch[1].replace(/_/g, '.') : '';
  }
  return '';
};

const getHmDeviceInfo = () => {
  const device = getDevice();
  const navigatorInfo = getNavigator();
  const connection = getConnection(navigatorInfo);
  const ua = navigatorInfo.userAgent || '';
  const systemName = device.os || navigatorInfo.platform || '';
  const systemVersion = parseSystemVersion(ua, device);

  return {
    appid: '',
    jhAppId: '',
    jh_channel: '',
    device_net_type: connection.effectiveType || connection.type || '',
    system_name: systemName,
    system_version: systemVersion,
    ip_addr: '',
  };
};

export default {
  data() {
    return {
      trackingTasks: [],
      trackingExecuting: false,
    };
  },
  computed: {
    referer_name() {
      return (this.$route && this.$route.meta && this.$route.meta.__refererName) || '';
    },
    referer_path() {
      return (this.$route && this.$route.meta && this.$route.meta.__refererPath) || '';
    },
    trackingUserInfo() {
      const account = this.$store && this.$store.state && this.$store.state.account;
      return (account && account.userInfo) || {};
    },
  },
  beforeRouteEnter(to, from, next) {
    to.meta.__refererName = from.meta ? from.meta.title : from.name;
    to.meta.__refererPath = from.fullPath;
    next();
  },
  methods: {
    getTrackingUserId() {
      const info = this.trackingUserInfo || {};
      return pickId(info.game_user_id, info.user_id);
    },
    getTrackingBoxUserId() {
      const info = this.trackingUserInfo || {};
      return pickId(info.boxUid, info.box_user_id, info.id, info.uid, info.forum_user_id);
    },
    getTrackingOpenId() {
      const info = this.trackingUserInfo || {};
      return pickId(info.open_id, info.openid);
    },
    executeTrackingTasks() {
      if (this.trackingExecuting || !this.trackingTasks.length) return Promise.resolve();

      this.trackingExecuting = true;
      const runNext = () => {
        const currentTask = this.trackingTasks.shift();
        if (!currentTask) {
          this.trackingExecuting = false;
          return Promise.resolve();
        }
        return Promise.resolve()
          .then(currentTask)
          .catch(() => {})
          .then(runNext);
      };

      return runNext();
    },
    EVENT_TRACKING(event, params = '', extra = {}) {
      return this.executeTrackingTasks().then(() => this.realEventTrack(event, params, extra));
    },
    realEventTrack(event, params = '', extra = {}) {
      const appParams = getHmDeviceInfo();
      const eventParams = withForumTrackingChannel(params);
      const body = {
        ...appParams,
        referer_path: this.referer_path,
        referer_name: this.referer_name,
        event,
        event_field: stringifyEventField(eventParams),
        channelId: '',
        userId: this.getTrackingUserId(),
        boxUserId: this.getTrackingBoxUserId(),
        openid: this.getTrackingOpenId(),
        systemVersion: appParams.system_version,
        osversion: appParams.system_version,
        deviceName: appParams.system_name,
        devicetype: appParams.system_name,
        inip: appParams.ip_addr,
        ...extra,
      };

      return eventTrackApi(body);
    },
    updateAppInfoCb() {},
  },
};
